import { genres, regions, years } from "@/mocks/movies";

export interface FilterState {
  type: string;
  genre: string;
  region: string;
  year: string;
}

interface FilterPanelProps {
  filters: FilterState;
  sort: string;
  onChange: (key: keyof FilterState, value: string) => void;
  onReset: () => void;
}

const typeOptions = [
  { value: "movie", label: "电影" },
  { value: "tv", label: "电视剧" },
];

function FilterGroup({
  title,
  options,
  active,
  onSelect,
}: {
  title: string;
  options: { value: string; label: string }[];
  active: string;
  onSelect: (value: string) => void;
}) {
  return (
    <div className="py-4 border-b border-background-200 last:border-b-0">
      <h3 className="text-sm font-semibold text-foreground-900 mb-3">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => onSelect(option.value)}
            className={`px-3 py-1.5 rounded-md text-xs transition-colors cursor-pointer whitespace-nowrap ${
              active === option.value
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-secondary-100"
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterPanel({ filters, onChange, onReset }: FilterPanelProps) {
  const genreOptions = [{ value: "", label: "全部" }, ...genres.map((g) => ({ value: g, label: g }))];
  const regionOptions = [{ value: "", label: "全部" }, ...regions.map((r) => ({ value: r, label: r }))];
  const yearOptions = [{ value: "", label: "全部" }, ...years.map((y) => ({ value: String(y), label: `${y} 年` }))];

  const hasFilter = Boolean(filters.genre || filters.region || filters.year);

  return (
    <div className="bg-background-50 rounded-lg border border-background-200 p-4 md:p-5">
      <div className="flex items-center justify-between mb-1">
        <span className="text-sm font-bold text-foreground-950 flex items-center gap-1.5">
          <i className="ri-filter-3-line text-primary-600" aria-hidden="true" />
          筛选条件
        </span>
        {hasFilter && (
          <button
            type="button"
            onClick={onReset}
            className="text-xs text-accent-600 hover:text-accent-700 cursor-pointer whitespace-nowrap"
          >
            重置筛选
          </button>
        )}
      </div>

      <FilterGroup
        title="内容分类"
        options={typeOptions}
        active={filters.type}
        onSelect={(value) => onChange("type", value)}
      />
      <FilterGroup
        title="影片类型"
        options={genreOptions}
        active={filters.genre}
        onSelect={(value) => onChange("genre", value)}
      />
      <FilterGroup
        title="出品地区"
        options={regionOptions}
        active={filters.region}
        onSelect={(value) => onChange("region", value)}
      />
      <FilterGroup
        title="上映年份"
        options={yearOptions}
        active={filters.year}
        onSelect={(value) => onChange("year", value)}
      />
    </div>
  );
}